import React from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import {yellow800} from 'material-ui/styles/colors'
const PickButton = (props) => {
// props.click, props.type
  var type = parseInt(props.type, 10);
  if (props.type === '') type = -1;
  const zapros = ( type === 0 ? {labelColor: 'white', backgroundColor: yellow800} : {} )

  return ( <RaisedButton 
            primary={ type > 0 ? true : false }
            {...zapros}
            disabled = { type < 0 ? true : false }
            {...props}
            /> );

};

export default PickButton;


// WEBPACK FOOTER //
// ./src/coms/PickButton.jsx